export { default as Img200 } from './processed/200/motherfatherson.jpg';
export { default as Img400 } from './processed/400/motherfatherson.jpg';
export { default as Imgthumb } from './processed/thumb/motherfatherson.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/motherfatherson.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/motherfatherson.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      175,
      80,
      112
    ],
    "_population": 0
  },
  "DarkVibrant": {
    "_rgb": [
      44,
      20,
      28
    ],
    "_population": 4,
    "_hsl": [
      0.9444444444444445,
      0.375,
      0.12549019607843137
    ]
  },
  "Muted": {
    "_rgb": [
      156,
      131,
      120
    ],
    "_population": 2878,
    "_hsl": [
      0.050925925925925854,
      0.1538461538461539,
      0.5411764705882354
    ]
  },
  "LightMuted": {
    "_rgb": [
      198,
      181,
      174
    ],
    "_population": 2922,
    "_hsl": [
      0.04861111111111113,
      0.17391304347826084,
      0.7294117647058824
    ]
  },
  "DarkMuted": {
    "_rgb": [
      74,
      61,
      56
    ],
    "_population": 2756,
    "_hsl": [
      0.04629629629629631,
      0.13846153846153852,
      0.2549019607843137
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/motherfatherson.js